import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <div className="footer-logo">
                <img
                  src="/logo/ThirdLocustWordmark.png"
                  alt="Third Locust Capital Management"
                  className="footer-logo-img"
                />
              </div>
              <p className="footer-description">
                Delivering superior risk-adjusted returns through disciplined investment strategies and rigorous market analysis.
              </p>
            </div>
          </div>

          <div className="footer-section">
            <h4>Contact Information</h4>
            <div className="contact-item">
              <span className="contact-label">Email:</span>
              <span>info@thirdlocust.com</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">Address:</span>
              <span> Denver, CO</span>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#story">Our Story</a></li>
              <li><a href="#team">Team</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Compliance</h4>
            <ul className="footer-links">
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#terms">Terms of Service</a></li>
              <li><a href="#disclosures">Risk Disclosures</a></li>
              <li><a href="#regulatory">Regulatory Information</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {new Date().getFullYear()} Third Locust Capital Management. All rights reserved.</p>
          </div>
          <div className="footer-disclaimer">
            <p className="disclaimer-text">
              Investment with Third Locust involves substantial risk. We try to mitigate that risk with a disciplined approach, but there are no guarantees of returns.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
